export const approvalStatusLabels = {
  draft: '下書き',
  pending: '承認待ち',
  approved: '承認済み',
  rejected: '差戻し'
};

export const salesStatusLabels = {
  not_presented: '未提示',
  presented: '提示済み',
  ordered: '受注',
  lost: '失注'
};

export const conversionStatusLabels = {
  not_converted: '未作成',
  converted: '作成済'
};

export const estimateTypeLabels = {
  annual: '年間',
  temporary: '臨時'
};

export const outputLayoutTypeLabels = {
  portrait_simple: '縦型・簡易（旧形式）',
  landscape_detailed: '横型・詳細',
  portrait_temporary: '縦型・臨時',
  portrait_annual: '縦型・年間'
};

export const lineTypeLabels = {
  detail: '明細',
  subtotal: '小計',
  discount: '値引',
  note: '注記'
};

export const taxTypeLabels = {
  taxable: '課税',
  tax_exempt: '非課税',
  out_of_scope: '対象外'
};

export const workTargetLabels = {
  none: '変換なし',
  annual: '年間予定',
  temporary: '臨時作業'
};

export const formatCurrency = (value) => {
  const amount = Number(value ?? 0);
  return Number.isFinite(amount) ? `${amount.toLocaleString('ja-JP')}円` : '0円';
};

export const displayRevisionNo = value =>
  Math.max(Number.parseInt(value, 10) || 0, 0) + 1;

export const formatRevisionLabel = value => `Rev.${displayRevisionNo(value)}`;

export const formatIsoDate = value => {
  if (!value) return '-';
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  return match ? `${match[1]}/${match[2]}/${match[3]}` : String(value);
};

export const formatDateTime = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat('ja-JP', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
};

export const extractApiErrors = (error) => {
  const data = error?.response?.data;
  if (!data) return ['通信に失敗しました'];

  const messages = [];
  if (typeof data.message === 'string') messages.push(data.message);

  const errors = data.errors;
  if (Array.isArray(errors)) {
    messages.push(...errors);
  } else if (errors && typeof errors === 'object') {
    Object.values(errors).forEach(value => {
      if (Array.isArray(value)) messages.push(...value);
      else if (value) messages.push(String(value));
    });
  }

  if (messages.length === 0 && typeof data.error === 'string') {
    messages.push(data.error);
  }

  return [...new Set(messages.filter(Boolean))];
};

export const isEstimateWriterRole = (role) => {
  return [0, 1, 999].includes(Number(role));
};
